import styled from "styled-components";

export const CustomerInfoStyled = styled.div`
  .customer_info_row {
    margin-bottom: 18px;
    display: flex;
    column-gap: 30px;
    .customer_info_head {
      flex-basis: 200px;
      flex-shrink: 0;
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
    }
    .customer_info_detail {
      min-width: 0;
      word-break: break-word;
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
    }
  }

  .theme_standard {
  }
`;
